<eze-registration-closed
	formName="referee"
	[url]="eventUrl"
	*ngIf="isClosed"
></eze-registration-closed>

<eze-smart-form-container *ngIf="!isClosed">
	<div header>
		<h1>Referee Registration</h1>
	</div>
	<div body>
		<div
			[innerHtml]="successHtml"
			*ngIf="successHtml"
			style="margin: 20px"
		></div>

		<div *ngIf="!successHtml">
			<form novalidate [formGroup]="form" (ngSubmit)="onSubmit()">
				<fieldset *ngIf="!isGuest">
					<eze-prefill-form
						[profile]="profile | async"
						[formReference]="form"
						(selectedPrefill)="hasSelectedPrefill = true"
					></eze-prefill-form>
				</fieldset>

				<fieldset *ngIf="message">
					<div
						style="margin-bottom: 15px"
						[innerHtml]="message"
					></div>
				</fieldset>

				<ng-container *ngIf="hasSelectedPrefill || isGuest">
					<fieldset>
						<eze-registration-closing-warning
							formName="referee"
						></eze-registration-closing-warning>

						<eze-alert></eze-alert>

						<div class="row">
							<div class="col-sm-4">
								<eze-input-container label="First Name">
									<input
										ezeInput
										type="text"
										id="name_first"
										[showValidation]="showValidation"
										formControlName="name_first"
										[showValidation]="showValidation"
									/>
								</eze-input-container>
							</div>
							<div class="col-sm-4">
								<eze-input-container label="Middle Name">
									<input
										ezeInput
										type="text"
										id="name_middle"
										[showValidation]="showValidation"
										formControlName="name_middle"
									/>
								</eze-input-container>
							</div>
							<div class="col-sm-4">
								<eze-input-container label="Last Name">
									<input
										ezeInput
										type="text"
										id="name_last"
										[showValidation]="showValidation"
										formControlName="name_last"
									/>
								</eze-input-container>
							</div>

							<div class="clearfix"></div>

							<div class="col-sm-4">
								<eze-input-container>
									<select
										ezeInput
										id="gender"
										[showValidation]="showValidation"
										formControlName="gender"
									>
										<option value="">Select...</option>
										<option
											*ngFor="
												let gender of ['Male', 'Female']
											"
											[value]="gender"
										>
											{{ gender }}
										</option>
									</select>
								</eze-input-container>
							</div>
						</div>

						<eze-birth-date
							formControlName="birth_date"
							[showValidation]="showValidation"
						></eze-birth-date>
					</fieldset>
					<fieldset>
						<!-- contact -->
						<eze-contact
							[formGroup]="form"
							[showValidation]="showValidation"
						></eze-contact>
					</fieldset>

					<fieldset *ngIf="membershipIdField">
						<div class="row">
							<div class="col-sm-12">
								<eze-input-container
									[label]="
										membershipIdField?.label ||
										'Membership ID'
									"
								>
									<input
										ezeInput
										type="text"
										id="membership_id"
										formControlName="membership_id"
										[showValidation]="showValidation"
									/>
								</eze-input-container>
							</div>
						</div>
					</fieldset>

					<fieldset>
						<div class="row">
							<div class="col-sm-12" formGroupName="school">
								<eze-input-container>
									<select
										ezeInput
										type="text"
										id="school"
										[showValidation]="showValidation"
										formControlName="id"
										[externalError]="
											form.get('school').getError('id')
										"
										required
									>
										<option value="null" disabled>
											Please Select...
										</option>
										<option
											*ngFor="let school of schools"
											[value]="school.id"
										>
											{{ school.name }} - ({{
												school.city
											}})
										</option>
										<option value="-1">
											Add New School
										</option>
									</select>
								</eze-input-container>
								<small
									>Please select 'Add New School' if your
									school is not in this list.</small
								>
								<br />
								<br />
							</div>
						</div>

						<div *ngIf="form.get(['school', 'id']).value === '-1'">
							<h3>Add New School</h3>

							<div class="row" formGroupName="school">
								<div class="col-sm-12">
									<eze-input-container required>
										<input
											ezeInput
											type="text"
											id="name"
											[showValidation]="showValidation"
											formControlName="name"
											[externalError]="
												form
													.get('school')
													.getError('name')
											"
										/>
									</eze-input-container>
								</div>

								<div class="col-sm-12">
									<eze-input-container required>
										<input
											ezeInput
											type="text"
											id="master"
											[showValidation]="showValidation"
											formControlName="master"
											[externalError]="
												form
													.get('school')
													.getError('master')
											"
										/>
									</eze-input-container>
								</div>

								<div class="col-sm-12">
									<eze-input-container required>
										<input
											ezeInput
											type="text"
											id="address"
											[showValidation]="showValidation"
											formControlName="address"
											[externalError]="
												form
													.get('school')
													.getError('address')
											"
										/>
									</eze-input-container>
								</div>

								<div class="col-sm-12">
									<eze-input-container>
										<input
											ezeInput
											type="text"
											id="address_2"
											[showValidation]="showValidation"
											formControlName="address_2"
										/>
									</eze-input-container>
								</div>

								<div class="col-sm-5">
									<eze-input-container required>
										<input
											ezeInput
											type="text"
											id="city"
											[showValidation]="showValidation"
											formControlName="city"
											[externalError]="
												form
													.get('school')
													.getError('city')
											"
										/>
									</eze-input-container>
								</div>

								<div class="col-xs-6 col-sm-3">
									<eze-input-container label="State" required>
										<select
											ezeInput
											id="school_state"
											[showValidation]="showValidation"
											formControlName="state"
											[externalError]="
												form
													.get('school')
													.getError('state')
											"
										>
											<option value="">Select...</option>
											<option
												*ngFor="let state of stateList"
												[value]="state"
											>
												{{ state }}
											</option>
										</select>
									</eze-input-container>
								</div>

								<div class="col-xs-6 col-sm-4">
									<eze-input-container required>
										<input
											ezeInput
											type="text"
											id="zip"
											[showValidation]="showValidation"
											formControlName="zip"
											[externalError]="
												form
													.get('school')
													.getError('zip')
											"
										/>
									</eze-input-container>
								</div>

								<div class="clearfix"></div>

								<div class="col-sm-6">
									<eze-input-container>
										<input
											ezeInput
											type="text"
											id="country"
											[showValidation]="showValidation"
											formControlName="country"
										/>
									</eze-input-container>
								</div>

								<div class="col-sm-6">
									<eze-input-container label="Website">
										<input
											ezeInput
											type="text"
											id="url"
											[showValidation]="showValidation"
											formControlName="url"
										/>
									</eze-input-container>
								</div>

								<div class="col-sm-6">
									<eze-input-container required>
										<input
											ezeInput
											type="text"
											id="phone"
											[showValidation]="showValidation"
											formControlName="phone"
											[textMask]="{
												mask: getPhoneMask(
													'school.phone'
												),
												guide: false
											}"
											[externalError]="
												form
													.get('school')
													.getError('phone')
											"
										/>
									</eze-input-container>
								</div>

								<div class="col-sm-6">
									<eze-input-container>
										<input
											ezeInput
											type="text"
											id="email"
											[showValidation]="showValidation"
											formControlName="email"
										/>
									</eze-input-container>
								</div>
							</div>
						</div>
					</fieldset>

					<fieldset>
						<div class="row">
							<div class="col-sm-6" *ngIf="roleRequired">
								<eze-input-container>
									<select
										ezeInput
										type="text"
										id="role"
										[showValidation]="showValidation"
										formControlName="role"
										multiple
									>
										<option
											*ngFor="let role of refRoles"
											[value]="role"
										>
											{{ role }}
										</option>
									</select>
								</eze-input-container>
							</div>
							<div class="col-sm-6">
								<eze-input-container
									label="Sparring Certification"
								>
									<select
										ezeInput
										type="text"
										id="cert_sparring"
										[showValidation]="showValidation"
										formControlName="cert_sparring"
										multiple
									>
										<option
											*ngFor="let cert of refCertSparring"
											[value]="cert"
										>
											{{ cert }}
										</option>
									</select>
								</eze-input-container>
							</div>
						</div>
						<div class="row">
							<div class="col-sm-6">
								<eze-input-container
									label="Poomsae Certification"
								>
									<select
										ezeInput
										type="text"
										id="cert_forms"
										[showValidation]="showValidation"
										formControlName="cert_forms"
										multiple
									>
										<option
											*ngFor="let cert of refCertForms"
											[value]="cert"
										>
											{{ cert }}
										</option>
									</select>
								</eze-input-container>
							</div>
						</div>
					</fieldset>

					<!-- parent if minor -->
					<fieldset *ngIf="isMinor(form)">
						<h3>Parent's Information (if minor)</h3>

						<!-- contact -->
						<div class="row">
							<div class="col-sm-4">
								<eze-input-container
									label="First Name"
									required
								>
									<input
										ezeInput
										type="text"
										id="parent_name_first"
										[showValidation]="showValidation"
										formControlName="parent_name_first"
										[externalError]="
											form.getError('parent_name_first')
										"
									/>
								</eze-input-container>
							</div>

							<div class="col-sm-4">
								<eze-input-container label="Middle Name">
									<input
										ezeInput
										type="text"
										id="parent_name_middle"
										[showValidation]="showValidation"
										formControlName="parent_name_middle"
										[externalError]="
											form.getError('parent_name_middle')
										"
									/>
								</eze-input-container>
							</div>

							<div class="col-sm-4">
								<eze-input-container label="Last Name" required>
									<input
										ezeInput
										type="text"
										id="parent_name_last"
										[showValidation]="showValidation"
										formControlName="parent_name_last"
										[externalError]="
											form.getError('parent_name_last')
										"
									/>
								</eze-input-container>
							</div>

							<div class="clearfix"></div>

							<div class="col-sm-6">
								<eze-input-container
									label="Parent's Email"
									required
								>
									<input
										ezeInput
										type="text"
										id="parent_email"
										[showValidation]="showValidation"
										formControlName="parent_email"
										[externalError]="
											form.getError('parent_email')
										"
									/>
								</eze-input-container>
							</div>

							<div class="col-sm-6">
								<eze-input-container
									label="Parent's Phone"
									required
								>
									<input
										ezeInput
										type="text"
										id="parent_phone"
										[showValidation]="showValidation"
										formControlName="parent_phone"
										[externalError]="
											form.getError('parent_phone')
										"
										[textMask]="{
											mask: getPhoneMask('parent_phone'),
											guide: false
										}"
									/>
								</eze-input-container>
							</div>
						</div>
					</fieldset>

					<fieldset
						*ngIf="form.get('shirt_size') || form.get('hotel')"
					>
						<div class="row">
							<div
								class="col-sm-12"
								*ngIf="form.get('shirt_size')"
							>
								<eze-input-container>
									<select
										ezeInput
										type="text"
										id="shirt_size"
										[showValidation]="showValidation"
										formControlName="shirt_size"
									>
										<option value="">
											Please Select...
										</option>
										<option
											*ngFor="let size of shirtSizes"
											[value]="size"
										>
											{{ size }}
										</option>
									</select>
								</eze-input-container>
							</div>

							<div class="col-sm-12">
								<eze-input-container
									label="I am Requesting a Hotel Room (Out of town Referees only)"
									*ngIf="form.get('hotel')"
								>
									<input
										ezeInput
										type="checkbox"
										id="subscription"
										formControlName="hotel"
										[showValidation]="showValidation"
									/>
								</eze-input-container>

								<small *ngIf="form.get('hotel')?.value">
									<p>
										Hotel rooms are provided to out of town
										Referees.
									</p>
									<br />
									<p>
										Hotel rooms when provided are double
										occupancy and shared with another
										referee.
									</p>
									<br />
									<p>
										The JKI Organizing Comittee is not
										responsible for additional charges
										outside the room fee during your stay at
										the hotel. These fees are the
										responsibility of the individual
										referee.
									</p>
									<br />
									<br />
								</small>
							</div>
						</div>
					</fieldset>

					<fieldset>
						<eze-input-container
							label="I want to subscribe to emails"
						>
							<input
								ezeInput
								type="checkbox"
								id="subscription"
								formControlName="subscription"
								[showValidation]="showValidation"
							/>
						</eze-input-container>

						<eze-input-container
							label="*By checking this box I attest that I am of legal adult age or the parent/ legal guardian of the applicant."
						>
							<input
								ezeInput
								type="checkbox"
								id="legal_age"
								formControlName="legal_age"
								[showValidation]="showValidation"
							/>
						</eze-input-container>

						<eze-input-container
							label="*By clicking this box I attest that I have NOT been convicted of a crime involving physical violence or sex-related offenses."
						>
							<input
								ezeInput
								type="checkbox"
								id="no_crime"
								formControlName="no_crime"
								[showValidation]="showValidation"
							/>
						</eze-input-container>

						<eze-input-container [label]="null">
							<div>
								*I consent to the
								<a (click)="openModal($event, 'waiver')"
									>Liability Waiver / Image Release / Medical
									Treatment</a
								>
							</div>
							<input
								ezeInput
								type="checkbox"
								id="waiver"
								formControlName="waiver"
								[showValidation]="showValidation"
							/>
						</eze-input-container>

						<eze-input-container [label]="null">
							<div>
								*I agree with the
								<a (click)="openModal($event, 'terms')"
									>Terms and Conditions</a
								>
							</div>
							<input
								ezeInput
								type="checkbox"
								id="terms_and_conditions"
								formControlName="terms_and_conditions"
								[showValidation]="showValidation"
							/>
						</eze-input-container>

						<eze-input-container
							label="*By clicking this box I attest that I have read and fully understood the Liability Waiver, the Image Release, the Medical Treatment and the Terms and Conditions. I attest that the information I have provided is true and correct. I understand that this registration will be verified via email and/or phone."
						>
							<input
								ezeInput
								type="checkbox"
								id="catchall"
								formControlName="catchall"
								[showValidation]="showValidation"
							/>
						</eze-input-container>

						<button type="subimit" style="display: none"></button>
					</fieldset>
				</ng-container>
			</form>
		</div>
	</div>
	<div footer>
		<eze-button
			(click)="onSubmit()"
			*ngIf="!successHtml && (hasSelectedPrefill || isGuest)"
			>Register</eze-button
		>
		<eze-button (click)="resetForm()" *ngIf="successHtml"
			>Register Another Referee</eze-button
		>
	</div>
</eze-smart-form-container>

<eze-waiver
	#waiverModal
	[header]="waiverHeader"
	[waiverText]="waiverText"
></eze-waiver>
<eze-terms #termsModal></eze-terms>

<!-- <br>

<pre>invalid = {{ form.invalid | json }}</pre>
<pre>errors = {{ form.errors | json }}</pre>
<pre>form.getError('parent_name_first') = {{ form.getError('parent_name_first') | json }}</pre>

<br> -->

<!-- <pre> value: {{ form.value | json }}</pre> -->
